import { NavLink } from 'react-router-dom';
import developmentIcon from '../media/icono1.png';
import marketingIcon from '../media/icono2.png';
import designIcon from '../media/icono3.png';
import itIcon from '../media/icono4.png';

const highlights = [
  {
    id: 'development',
    icon: developmentIcon,
    title: 'Desarrollo web y móvil',
    description:
      'Ayudamos a las empresas a elevar su valor a través del desarrollo personalizado, diseño de productos, control de calidad y consultoría.',
  },
  {
    id: 'marketing',
    icon: marketingIcon,
    title: 'Marketing',
    description:
      'Ayudamos a tu marca a elevar su valor a través del desarrollo de un plan de marketing personalizado, análisis de social media, diseño de productos y control de calidad.',
  },
  {
    id: 'design',
    icon: designIcon,
    title: 'Diseño',
    description:
      'Diseñamos desde el logotipo hasta la imagen corporativa completa, para que estés listo para empezar con una campaña de marketing digital.',
  },
  {
    id: 'it',
    icon: itIcon,
    title: 'Servicios IT',
    description:
      'Dispondrá de profesionales a la medida de sus necesidades, que mejorarán el rendimiento de los procesos de trabajo y le permitirán destinar recursos a otras áreas.',
  },
];

/**
 * Resumen de servicios en el home.
 *
 * El CSS espera dos filas de dos tarjetas, así que la lista se parte en pares
 * en lugar de repetir cuatro bloques de marcado casi idénticos.
 */
const ServicesSection = () => {
  const rows = [highlights.slice(0, 2), highlights.slice(2, 4)];

  return (
    <section className="servicesSection" id="services">
      <h3>Servicios</h3>
      <p className="textBold servicesSectionSubtitle">Todo lo que necesitas lo tenemos aquí</p>

      {rows.map((row, index) => (
        <div className="servicesSectionGrid" key={row[0]?.id ?? index}>
          {row.map(({ id, icon, title, description }) => (
            <div className="servicesSectionCard" key={id}>
              <img src={icon} alt="" />
              <div className="servicesSectionCardInfo">
                <h4>{title}</h4>
                <p>{description}</p>
              </div>
            </div>
          ))}
        </div>
      ))}

      <NavLink to="/services" className="btnDark">
        Leer más
      </NavLink>
    </section>
  );
};

export default ServicesSection;
